





























import _, { isNumber } from 'lodash';

import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';

@Component
export default class ConfirmModal extends Vue {
  @Prop() public message: string;
	@Prop({default: "Yes"}) public positivelabel: string;
	@Prop({default: "No"}) public negativelabel: string;
	@Prop({default: "confirmModal"}) public refname: string;


	public positive() {
		this.$emit("positiveclick")
		const modal = (this.$parent.$refs[this.refname] as any).$el;
    ($(modal) as any).modal("hide");
	}
  public negative() {
		this.$emit("negativeclick")
    const modal = (this.$parent.$refs[this.refname] as any).$el;
    ($(modal) as any).modal("hide");
  }
}

